module.exports = __webpack_public_path__ + "static/jc04657-preparation-administration-1-9308cffef878d903dd2a3581a44413ea.png";